import React from "react";
import moment from "moment";
import PostReview from "./PostReveiw";

const Reviews = ({ isbusiness, visible, isLoggedIn, business_id, handleRefresh, showMoreItems }) => {
  // const user_uuid = localStorage.getItem("user_uuid");
  // const hasReviewed = isbusiness?.userReview?.find((review) => review.user_uuid === user_uuid)
  return <div style={{ marginTop: 20 }}>
    {isbusiness?.userReview?.length > 0 ? (
      <div style={{ display: 'flex', padding: '0 20px', gap: 30, flexWrap: 'wrap', alignItems: 'baseline' }}>
        {isbusiness?.userReview.slice(0, visible).map((item, index) => {
          return (
            <div className="review-container" key={index}>
              <div className="business-review-profile-wrap" style={{ gap: 15 }}>
                <div>
                  <img
                    src={
                      item?.userProfile[0]?.profile_image &&
                        item?.userProfile[0]?.profile_image !== "N/A"
                        ? item?.userProfile[0]?.profile_image
                        : "../images/user.svg"
                    }
                    width={50}
                    height={50}
                    className="img-fluid"
                  />
                </div>
                <div>
                  <div className="business-review-name" style={{ textTransform: 'capitalize' }}>
                    {item?.userProfile[0]?.name}
                  </div>
                  <div className="business-review-time">
                    {moment(item?.created_at).format("ll")}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <div className="review-text">
                  <div className="businessDetails-reviewStar" style={{ paddingBottom: "8px" }}>
                    {isbusiness?.reviewAverage != undefined &&
                      Array.from(Array(parseInt(item?.rating)), (e, i) => {
                        return (
                          <li key={i} className="reviewStar">
                            <i className="fa-solid fa-star" />
                          </li>
                        );
                      })}
                    {Array.from(
                      { length: 5 - parseInt(item?.rating || 0) },
                      (e, j) => {
                        return (
                          <li key={j + 5} style={{ listStyle: "none" }}>
                            <i
                              style={{ marginRight: "3px", color: '#3ca059' }}
                              className="fa-regular fa-star"
                            />
                          </li>
                        );
                      }
                    )}
                  </div>

                  <div className="businessDetails-review-comment">
                    {item.comment}
                  </div>
                </div>
              </div>
            </div>
          );
        })
        }
      </div>
    ) : (
      <div className="businessDetails-Noreview">
        <img src="/images/emtystateReview.svg" />
        <div className="businessDetails-Noreview-content">
          No review found. <br />
          Be the first person to add a review.
        </div>
      </div>
    )}
    {isbusiness?.userReview?.length > visible && (
      <button onClick={showMoreItems} style={{paddingTop:'40px'}}>
        <img src="../images/angle-down.png" /> See more
        reviews
      </button>
    )}
    {isLoggedIn && (
      <PostReview business_id={business_id} handleRefresh={handleRefresh} />
    )}
  </div>
};

export default Reviews;
